import React,{useContect,createContext} from "react";
export const ToursContext=createContext();
